// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1__0S","cls2":"Unibrow-cls2_mFj Unibrow-cls1__0S"};